import React from 'react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { OFFER_ANCHOR, PRODUCT_NAME, tomos } from '../data/content';

/* Mismos colores que los lomos de los tomos en la imagen del pack */
const TOMO_COLORS = ['bg-red-600 text-white', 'bg-orange-500 text-ink', 'bg-green-600 text-white', 'bg-blue-600 text-white', 'bg-violet-600 text-white', 'bg-cyan-500 text-ink'];
export function SolutionSection() {
  return <section aria-labelledby="solucion" className="bg-brand" data-id="element-152" data-mp="12i03zudg05w">
      <div className="mx-auto max-w-2xl px-3 py-5 text-center sm:px-5" data-id="element-153" data-mp="3t7lsfhlbvcfs">
        <p className="font-sub text-sm font-semibold leading-tight text-highlight" data-id="element-154" data-mp="auxe6m2js4li">
          La solución que estabas buscando — un sistema 6 en 1
        </p>
        <h2 id="solucion" className="mt-1.5 font-display text-[1.5rem] font-extrabold leading-[1.1] tracking-tight text-white sm:text-4xl" data-id="element-155" data-mp="5xe0bn9rhtu3">
          <span className="text-highlight" data-id="element-156" data-mp="fus9d1tcvgcd">6 tomos en un solo sistema,</span>{' '}
          creados para aprender desde cero.
        </h2>
        <p className="mt-1 font-display text-xs font-extrabold uppercase leading-tight text-white/80 sm:text-sm" data-id="element-157" data-mp="36cysahcpc4pg">
          {PRODUCT_NAME}
        </p>
        <p className="mx-auto mt-1.5 max-w-xl text-sm leading-snug text-white/90" data-id="element-158" data-mp="3fa96obktg9yl">
          No es simplemente otro ebook de contabilidad. Es una{' '}
          <strong className="font-bold text-highlight" data-id="element-159" data-mp="3p9huemp38sci">ruta de aprendizaje</strong>{' '}
          que organiza los conocimientos fundamentales para que comprendas qué
          estudiar primero, cómo registrar operaciones, cómo funcionan los
          principales impuestos y cómo aplicar todo mediante ejercicios
          prácticos.
        </p>

        <ol className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-160" data-mp="6u78lrjf3500">
          {tomos.map((tomo, i) => <Reveal key={tomo.title} as="li" delay={i * 0.03} className="flex h-full overflow-hidden rounded-xl border-2 border-highlight bg-white text-left text-ink" data-id="element-161" data-mp="bvmtnjllhbie" data-mpi={i}>
              <span className={`flex w-14 flex-shrink-0 flex-col items-center justify-center gap-0.5 ${TOMO_COLORS[i]}`} data-id="element-162" data-mp="2cuqgh6sgaa2c">
                <span className="font-sub text-[10px] font-semibold uppercase tracking-wider" data-id="element-163" data-mp="2mno2hmwnih5p">
                  Tomo
                </span>
                <span className="font-display text-2xl font-black leading-none" data-id="element-164" data-mp="2htt8nqnc0lsw">
                  {i + 1}
                </span>
              </span>
              <div className="p-2.5" data-id="element-165" data-mp="2rmh5glebaprm">
                <h3 className="font-sub text-sm font-semibold leading-tight" data-id="element-166" data-mp="2rlftmeph1z8u">
                  <span className="sr-only" data-id="element-167" data-mp="35k5rhwk482y9">Tomo {i + 1} — </span>
                  {tomo.title}
                </h3>
                <p className="mt-0.5 text-xs leading-snug text-ink/80 sm:text-sm" data-id="element-168" data-mp="30n6xde0gbw02">
                  {tomo.desc}
                </p>
              </div>
            </Reveal>)}
        </ol>

        <CtaButton href={OFFER_ANCHOR} className="mt-4" data-id="element-169" data-mp="169xnvm7woaht">
          🚀 Sí, quiero comenzar ahora
        </CtaButton>
      </div>
    </section>;
}